import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { IonicVue } from '@ionic/vue'
import { createStore } from 'vuex';

import store from './store'

import './util/filters';
import './registerServiceWorker';
// import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';
import 'vue-search-select/dist/VueSearchSelect.css'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import '@vuepic/vue-datepicker/dist/main.css';

import { tryParseServiceError, migratedTryParseServiceError } from "./service";
import { ToastUtils } from "./util/toast-utils";
import { VueQrcodeReader } from "vue-qrcode-reader";
import { eventMethod } from '@ionic/core/dist/types/utils/overlays';


const app = createApp(App);

// Use Ionic Vue plugin
app.use(IonicVue);
// Use VueQrcodeReader plugin
app.use(VueQrcodeReader)

// console.log(app.version)
// Disable production tip
// app.config.productionTip = false;

// Set up global error handler
app.config.errorHandler = (error, vm, info) => {
  console.log('global error handling')
  if (error) {
    const errorMessage = typeof error === 'string' ? error : JSON.stringify(error);
    // const serviceError = tryParseServiceError(errorMessage);
    const serviceError = migratedTryParseServiceError(errorMessage);
    // new ToastUtils().presentToast(serviceError ? serviceError.description : error);
    new ToastUtils().presentToast(serviceError.description);
    if (typeof serviceError === 'object' && 'statusCode' in serviceError && serviceError.statusCode === 401) {
      window.localStorage.clear();
      window.location.href = '/login';
    }
  }
};


// Mount the app with router and store
app.use(router).use(store).mount('#app');
